<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    <IFormField>
      <label iLabel>{{ t("keyword-segment-modal.segment_name") }}</label>
      <input
        iInput
        [maxLength]="80"
        size="sm"
        data-testid="segment-name-input"
        [(ngModel)]="name"
        placeholder="{{ t('keyword-segment-modal.name_input_tooltip') }}"
        autoFocus
      />
    </IFormField>

    <div class="flex min-h-0 flex-1 flex-col gap-2">
      <div class="text-sm font-medium text-gray-700">Keywords</div>
      <div class="min-h-0 flex-1">
        <app-keyword-list-manager
          [initTargetings]="segmentTargetings()"
          (targetingsChanged)="onKeywordsChanged($event)"
          [isReadOnly]="isReadOnly"
        />
      </div>
    </div>

    <div class="flex justify-end gap-2">
      @if (!isReadOnly) {
        <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.cancel") }}</button>
        <button
          iButton
          testId="btn-confirm-segment"
          type="submit"
          [loading]="loading()"
          [disabled]="saveDisabled()"
          (click)="saveSegment()"
        >
          {{ t("common.save") }}
        </button>
      } @else {
        <button iButton variant="secondary" (click)="modalRef.close()">{{ t("common.close") }}</button>
      }
    </div>
  </div>
</ng-container>
